import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface KimThread {
  id: string;
  name: string;
  createdDate: string;
}

export const useGetKimThreads = (matterId?: string, subsetId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<KimThread[], ApiError>(
    [QueryEntity.KimThreads, { subsetId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads`,
        fetchConfigGET,
      );
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
